<div class="loading-container" *ngIf="loading || loadFailed">
  <app-loader variant="almostready" [failed]="loadFailed" [failedMessage]="error || ''" (retry)="retryLoad()"></app-loader>
</div>

<!-- The failed loader above already shows the reason + Retry; this stays for the
     non-retryable errors (e.g. a scan that is simply not there). -->
<div class="error-container" *ngIf="!loading && !loadFailed && error">
  <div class="error-message">{{ error }}</div>
</div>

<div
  class="mk-results"
  *ngIf="!loading && !error && vm"
  [attr.dir]="(rtlService.$isRTL | async) ? 'rtl' : 'ltr'"
>
  <!-- Desktop sidebar — hidden on mobile via theme CSS -->
  <nav class="desktop-sidebar" id="desktop-nav">
    <div style="display:flex;align-items:center;gap:10px;padding:4px 8px 14px;border-bottom:1px solid var(--g100);margin-bottom:10px;">
      <img [src]="brand.iconSrc" [alt]="brand.config.brandName" width="32" height="32" style="display:block;width:32px;height:32px;border-radius:8px;object-fit:contain;flex-shrink:0;" />
      <div>
        <div style="font-size:14px;font-weight:700;color:var(--navy);letter-spacing:-0.2px;">{{ brand.config.brandName }}</div>
        <div style="font-size:11px;color:var(--g400);">{{ 'results.nav.fullReport' | translate }}</div>
      </div>
    </div>

    <button class="dsk-nav-item" [class.active]="activePanel === 'paid-intro'" type="button" (click)="goPanel('paid-intro')">
      <span class="dsk-nav-dot" style="background:var(--g300);"></span>
      <span class="dsk-nav-text">{{ 'results.nav.results' | translate }}</span>
    </button>

    <button
      *ngFor="let s of sidebar; trackBy: trackByPanelId"
      class="dsk-nav-item"
      [class.active]="activePanel === s.panelId"
      type="button"
      (click)="goPanel(s.panelId)"
    >
      <span class="dsk-nav-dot" [style.background]="s.dot"></span>
      <span class="dsk-nav-text">{{ s.labelKey | translate }}</span>
      <span *ngIf="s.score != null" class="dsk-nav-score" [style.color]="s.scoreColor">{{ s.score }}</span>
    </button>

    <button *ngIf="dailyLoop" class="dsk-nav-item" [class.active]="activePanel === 'paid-0'" type="button" (click)="goPanel('paid-0')" style="margin-top:2px;">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--pk)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
      <span class="dsk-nav-text" style="color:var(--pk);font-weight:700;">{{ 'results.domains.routine.title' | translate }}</span>
    </button>

    <div style="height:1px;background:var(--g100);margin:14px 4px;"></div>

    <button class="dsk-nav-item" style="font-size:12px;" type="button" (click)="goDoctorReport()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0;opacity:0.6;"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18" /><path d="M9 21V9" /></svg>
      <span class="dsk-nav-text">{{ 'results.nav.doctorReport' | translate }}</span>
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="opacity:0.4;flex-shrink:0;" [style.transform]="isRtl ? null : 'scaleX(-1)'"><polyline points="15 18 9 12 15 6" /></svg>
    </button>
  </nav>

  <div class="screen active">
    <div id="section-carousel" #sectionCarousel>
      <div
        class="paid-panel"
        [class.active]="activePanel === 'paid-intro'"
        [class.desktop-active]="activePanel === 'paid-intro'"
        id="paid-intro"
      >
        <app-results-intro [vm]="vm" (goPanel)="goPanel($event)" (goDoctor)="goDoctorReport()" (goPaywall)="openPaywall()"></app-results-intro>
      </div>

      <div
        class="paid-panel"
        [class.active]="activePanel === 'paid-1'"
        [class.desktop-active]="activePanel === 'paid-1'"
        id="paid-1"
        *ngIf="vm.imprint"
      >
        <button class="mk-back-btn" type="button" (click)="goPanel('paid-intro')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" [style.transform]="isRtl ? 'scaleX(-1)' : null"><polyline points="15 18 9 12 15 6" /></svg>
          <span>{{ 'results.nav.backToResults' | translate }}</span>
        </button>
        <app-imprint-panel [vm]="vm.imprint" [active]="activePanel === 'paid-1'" [progress]="vm.progress.imprint" (goPaywall)="openPaywall()"></app-imprint-panel>
      </div>

      <div
        class="paid-panel"
        [class.active]="activePanel === 'paid-2'"
        [class.desktop-active]="activePanel === 'paid-2'"
        id="paid-2"
        *ngIf="vm.symptoms"
      >
        <button class="mk-back-btn" type="button" (click)="goPanel('paid-intro')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" [style.transform]="isRtl ? 'scaleX(-1)' : null"><polyline points="15 18 9 12 15 6" /></svg>
          <span>{{ 'results.nav.backToResults' | translate }}</span>
        </button>
        <app-symptoms-panel [vm]="vm.symptoms" [active]="activePanel === 'paid-2'" [progress]="vm.progress.symptoms" (goPaywall)="openPaywall()"></app-symptoms-panel>
      </div>

      <div
        class="paid-panel"
        [class.active]="activePanel === 'paid-3'"
        [class.desktop-active]="activePanel === 'paid-3'"
        id="paid-3"
        *ngIf="vm.think"
      >
        <button class="mk-back-btn" type="button" (click)="goPanel('paid-intro')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" [style.transform]="isRtl ? 'scaleX(-1)' : null"><polyline points="15 18 9 12 15 6" /></svg>
          <span>{{ 'results.nav.backToResults' | translate }}</span>
        </button>
        <app-think-panel [vm]="vm.think" [active]="activePanel === 'paid-3'" [progress]="vm.progress.think" (goPaywall)="openPaywall()"></app-think-panel>
      </div>

      <div
        class="paid-panel"
        [class.active]="activePanel === 'paid-s'"
        [class.desktop-active]="activePanel === 'paid-s'"
        id="paid-s"
        *ngIf="vm.sense"
      >
        <button class="mk-back-btn" type="button" (click)="goPanel('paid-intro')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" [style.transform]="isRtl ? 'scaleX(-1)' : null"><polyline points="15 18 9 12 15 6" /></svg>
          <span>{{ 'results.nav.backToResults' | translate }}</span>
        </button>
        <app-sense-panel [vm]="vm.sense" [active]="activePanel === 'paid-s'" (goPaywall)="openPaywall()" (startCheck)="startSenseCheck()"></app-sense-panel>
      </div>

      <div
        *ngIf="dailyLoop"
        class="paid-panel"
        [class.active]="activePanel === 'paid-0'"
        [class.desktop-active]="activePanel === 'paid-0'"
        id="paid-0"
      >
        <button class="mk-back-btn" type="button" (click)="goPanel('paid-intro')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" [style.transform]="isRtl ? 'scaleX(-1)' : null"><polyline points="15 18 9 12 15 6" /></svg>
          <span>{{ 'results.nav.backToResults' | translate }}</span>
        </button>
        <app-routine-panel [firstName]="vm.firstName" [locked]="routineLocked" [doctorLocked]="doctorLocked" (goPaywall)="openPaywall()"></app-routine-panel>
      </div>
    </div>

    <div class="carousel-dots" id="section-carousel-dots">
      <div
        class="carousel-dot"
        *ngFor="let id of dotPanels; trackBy: trackByDot"
        [class.active]="activePanel === id"
        (click)="goPanel(id)"
      ></div>
    </div>

    <div class="disclaimer" style="margin-top:24px;" [innerHTML]="'results.disclaimer' | translate"></div>
  </div>
</div>

<!-- Results paywall — approved v2 design as a scrollable bottom-sheet
     (locked-flow spec §4b). Top-level (OUTSIDE the *ngIf="vm" block) so it also
     renders on a locked repeat scan (402, vm null), where it replaces the old
     blurred-teaser screen (N57-10). Variant A first check (free CTA stays),
     variant B returning / locked. -->
<app-paywall-sheet
  *ngIf="showPaywall"
  [variant]="paywallVariant"
  [scanId]="scanId"
  (close)="closePaywall()"
  (purchased)="onPurchased()"
></app-paywall-sheet>

<!-- Locked-paywall exit → soft "we saved your scan" confirmation (never a
     dead-end). The scan is already persisted as completed-locked; she can reopen
     it from the profile pending list (pending-locked spec §Paywall exit). -->
<div class="mk-saved-overlay" *ngIf="savedConfirm" [attr.dir]="(rtlService.$isRTL | async) ? 'rtl' : 'ltr'">
  <div class="mk-saved-card">
    <div class="mk-saved-check">✓</div>
    <div class="mk-saved-title">{{ 'paywall.savedTitle' | translate }}</div>
    <p class="mk-saved-sub">{{ 'paywall.savedSub' | translate }}</p>
    <button type="button" class="mk-saved-btn" (click)="leaveSaved()">
      {{ 'paywall.exitLink' | translate }}
    </button>
  </div>
</div>
